import React, { Fragment, useEffect, useState } from "react"
import { CardRow, Card, Title } from "./CustomRulesStyled"
import { useCardCombinations } from "./CUSTOM_RULES_CONTENT"
import { GAME_RULES_PROPS } from "../interface"

export default function CustomRules({ colors, coefs }: GAME_RULES_PROPS) {
  const [coefArr, setcoefArr] = useState([
    "1",
    "2",
    "3",
    "5",
    "9",
    "22",
    "60",
    "800",
  ])

  useEffect(() => {
    if (coefs) {
      setcoefArr(coefs[0])
    }
  }, [coefs])

  const [combArray] = useCardCombinations(coefArr)

  return (
    <Fragment>
      {combArray.map((item: any, id: number) => (
        <article key={id}>
          <Title>{item.combinationName}</Title>
          <span>{item.coef}X</span>
          <CardRow className="cardRow">
            {item.cards.map((card: any, index: number) => (
              <Card
                className="card"
                key={index}
                isWin={card.win}
                colors={card.color}
                background={colors.customColor}
              >
                <p>{card.name}</p>
                {card.suit}
              </Card>
            ))}
          </CardRow>
        </article>
      ))}
    </Fragment>
  )
}
